export function getTools() {
  return [
    { id: 1, name: "Color Grid Generator", category: "Design", path: "/color-palette-grid-generator", comingSoon: false },
    { id: 2, name: "Text Reformatter", category: "Utility", path: "/text-reformatter", comingSoon: false },
  ];
}
